<template>
  <div>
    <!--grid selection-->
    <h5 class="mx-8">{{ $t('launchpadLayout.gridSelection') }}</h5>
    <v-row class="mx-5 my-2">
      <v-col md="6" cols="6">
        <v-btn
          disabled
          @click="selectedGrid('3x2')"
          class="py-9 align-center d-flex justify-start grid"
        >
          <v-chip class="pa-4 mx-5">
            <v-icon>mdi-grid</v-icon>
          </v-chip>
          <div class="d-flex flex-column align-start">
            <span class="text-h6 font-weight-bold">{{ $t('launchpadLayout.grid3x2') }}</span>
            <span style="color: #ccc" class="text-caption"
              >{{ $t('launchpadLayout.grid3x2Desc') }}</span
            >
          </div>
        </v-btn>
      </v-col>

      <v-col md="6" cols="6">
        <v-btn
          disabled
          @click="selectedGrid('2x2')"
          class="py-9 align-center d-flex justify-start grid"
        >
          <v-chip
            :color="selected === '2x2' ? '#febd0b' : ''"
            class="pa-4 mx-5"
          >
            <v-icon>mdi-grid-large</v-icon>
          </v-chip>
          <div class="d-flex flex-column align-start">
            <span class="text-h6 font-weight-bold">{{ $t('launchpadLayout.grid2x2') }}</span>
            <span style="color: #ccc" class="text-caption"
              >{{ $t('launchpadLayout.grid2x2Desc') }}</span
            >
          </div>
        </v-btn>
      </v-col>
    </v-row>

    <h5 class="mx-8">{{ $t('launchpadLayout.layoutSelection') }}</h5>
    <v-row class="mx-5 d-flex align-center" v-if="deletedComponents.length > 0">
      <h6 class="my-3 ml-3 mr-10">{{ $t('launchpadLayout.deletedComponents') }}</h6>
      <div
        class="d-flex align-center justify-space-between mx-2"
        v-for="(c, id) in deletedComponents"
      >
        <v-btn
          icon
          x-small
          @click="marketsComponents.unshift(c)"
          style="width: 10%"
        >
          <v-chip x-small outlined>{{ c }}</v-chip>
        </v-btn>
      </div>
    </v-row>
    <v-row class="ma-3 d-flex justify-center">
      <draggable
        :disabled="true"
        v-model="marketsComponents"
        class="d-flex flex-wrap justify-center"
        :options="{ animation: 150 }"
      >
        <v-col
          :key="id"
          v-for="(comp, id) in visibleComponents"
          :cols="selected === '3x2' ? '4' : '6'"
        >
          <div
            class="d-flex align-center justify-space-between layout-selection-disabled"
          >
            <div class="pax-0 ma-0 font-weight-bold">{{ comp }}</div>
            <v-btn
              disabled
              @click="deleteComponent(id)"
              x-small
              icon
              class="close-btn"
            >
              <v-icon x-small>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-col>
      </draggable>
    </v-row>
  </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
  components: { draggable },
  data() {
    return {
      selected: "3x2",
      marketsComponents: [
        this.$t('launchpadLayout.components.news'),
        this.$t('launchpadLayout.components.news'),
        this.$t('launchpadLayout.components.currencyPair'),
        this.$t('launchpadLayout.components.economicCalendar'),
        this.$t('launchpadLayout.components.economicCalendar'),
        this.$t('launchpadLayout.components.crossQuotes'),
      ],
      deletedComponents: [],
    };
  },
  computed: {
    visibleComponents() {
      if (this.selected === "3x2") {
        return this.marketsComponents;
      }
      return [...new Set(this.marketsComponents)];
    },
  },
  methods: {
    selectedGrid(type) {
      this.selected = type;
    },
    deleteComponent(id) {
      this.deletedComponents.push(this.marketsComponents[id]);
      this.marketsComponents.shift(this.marketsComponents[id]);
    },
  },
};
</script>

<style scoped>
.v-btn {
  width: 100%;
}
.grid {
  border: 1px solid rgba(255, 255, 255, 0.286);
  border-radius: 10px;
  cursor: pointer;
}
.drag {
  cursor: pointer;
}
.layout-selection {
  border: 1px solid #febccd0b;
  background: #febd0b63;
  padding: 1rem;
  white-space: nowrap;
  border-radius: 10px;
}
.layout-selection-disabled {
  border: 1px solid #898989;
  background: #363636;
  padding: 1rem;
  white-space: nowrap;
  border-radius: 10px;
  color: #585858;
}
.close-btn {
  width: 10%;
}
.disabled {
  color: #ccc;
}
.active-grid {
  border: 1px solid #febd0b;
  border-radius: 10px;
  color: #febd0b;
  cursor: pointer;
}
</style>
